<template>
  <v-row>
    <v-col
      v-for="setting in settings"
      :key="setting.key"
      cols="4"
    >
      <div class="amount-box">
        <v-text-field
          :id="'id-'+setting.key"
          type="number"
          :value="convertedValues[setting.key]"
          @input="val => emitInput(val, setting.key)"
          :suffix="currencySymbol"
          :rules="[(v) => (v >= 1 && v <= 99 && Number.isInteger(Number(v))) || 'Wert muss zwischen 1 und 99 liegen']"
          class="amount-box__field"
          outlined
          dense
          hide-details="auto"
          autocomplete="off"
        />
        <reset-icon :setting="setting" @clear="$emit('clear', setting.key)" @set-here="$emit('set-here', setting.key)" />
      </div>
      <div v-if="setting.nextFrame.source !== undefined" class="text-caption text-center mt-1" :class="isInherited[setting.key] ? '' : 'text--disabled'">
        &#252;bernommen von <span class="font-weight-bold">{{ getInheritedFromOrgName(setting) }}</span>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
import ResetIcon from '@/components/device/ResetIcon'

export default {
  name: 'BeitragswaehlerGroup',
  components: { ResetIcon },
  props: {
    settings: {
      type: Array,
      required: true
    },
    currency: {
      type: String,
      default: 'EUR'
    },
  },
  data () {
    return {
      localInput: {}
    }
  },
  computed: {
    ...mapGetters('organization', ['allOrganizations']),
    currencySymbol () {
      return this.$options.filters.currencySymbol(this.currency)
    },
    convertedValues () {
      const res = {}
      for (const s of this.settings) {
        if (this.localInput[s.key] !== undefined) {
          res[s.key] = this.localInput[s.key]
        } else {
          res[s.key] = s.currentValue / 100
        }
      }
      return res
    },
    isInherited () {
      const res = {}
      for (const s of this.settings) {
        res[s.key] = s.nextFrame.source !== undefined && !s.locallySet
      }
      return res
    },
  },
  watch: {
    settings: {
      immediate: true,
      handler (newVal, oldVal) {
        if (!oldVal || newVal.length !== oldVal.length || newVal.some((s, i) => s.key !== oldVal[i].key)) {
          this.localInput = {}
        }
      }
    }
  },
  methods: {
    getInheritedFromOrgName (setting) {
      let name = null
      const url = setting.nextFrame.source
      if (url && this.allOrganizations[url]) {
        name = this.allOrganizations[url]?.name
      }
      return name || 'übergeordneter Organisation'
    },
    emitInput (val, key) {
      this.$set(this.localInput, key, val)
      let numericVal
      if (val === '' || val === null || val === undefined) {
        numericVal = null
      } else {
        numericVal = Math.round(parseFloat(val) * 100)
        if (isNaN(numericVal)) {
          numericVal = null
        } else {
          // Betragswähler amounts are shown/edited in whole euros between 1 and 99 (see the
          // field's :rules); never let an out-of-range typed value reach the saved setting.
          numericVal = Math.min(9900, Math.max(100, numericVal))
        }
      }
      this.$emit('input', { key, value: numericVal })
    }
  }
}
</script>

<style scoped>
.amount-box {
  display: flex;
  align-items: center;
  gap: 4px;
}
.amount-box__field {
  text-align: center;
}
.amount-box__field /deep/ input {
  text-align: center;
  font-size: 17px;
  font-weight: 600;
}
</style>
